// extracted by mini-css-extract-plugin
export var buttonContainer = "_8z-1";
export var fontSizeSelect = "_8z-3";
export var formatSelect = "_8z-2";
export var formats = "_8z-4";
export var hidden = "_8z-5";
export var icon = "_8z-6";
export var select = "_8z-0";